module.exports = __webpack_public_path__ + "img/logo.4577d74b.png";